import { Link } from "react-router-dom";

/**
 * Privacy Policy and Terms of Service, as routes with no copy in them yet.
 *
 * The pages exist because things already link to them -- the signup consent step asks people to accept
 * both, and until now those were words with nowhere to go, which is a bad look on a service handling
 * minors' data. The copy itself is deliberately not written here: legal drafting for this project is
 * the owner's, not something to generate (CLAUDE.md), and a plausible-sounding privacy policy that
 * nobody has checked is worse than an honest placeholder.
 *
 * Anyone landing here sees a straight statement of that rather than lorem ipsum pretending to be terms.
 */
export function LegalPage({ title }: { title: "Privacy Policy" | "Terms of Service" }) {
  return (
    <div className="marketing">
      <section className="marketing-hero">
        <h1>{title}</h1>
        <p className="marketing-lede">
          This document hasn&rsquo;t been published yet. If you need it before signing up, please ask
          your coach and they will get it to you.
        </p>
        <Link className="link-button marketing-cta" to="/">
          Back to home
        </Link>
      </section>
    </div>
  );
}
